import { useEffect, useState } from 'react';

export const useSupports = (
    supportCondition: string,
    defaultValue: boolean | undefined,
): boolean | undefined => {
    // Create a state to store declaration check result
    const [checkResult, setCheckResult] = useState<boolean | undefined>(defaultValue);

    useEffect(() => {
        // Run check as a side effect, on user side only
        try {
            // Check if CSS.supports is available
            if (typeof CSS !== 'undefined' && CSS.supports) {
                const result = CSS.supports(supportCondition);
                setCheckResult(result);
            } else {
                // If CSS.supports is not available, keep the default value
                setCheckResult(defaultValue);
            }
        } catch (error) {
            // If CSS.supports throws an error, keep the default value
            console.error('Error checking support condition', error);
            setCheckResult(defaultValue);
        }
    }, [supportCondition, defaultValue]);

    return checkResult;
};
